import { InjectionToken } from '@angular/core';
import { HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { User } from '~auth/model';


export interface RequestOptions {
  headers?: HttpHeaders;
  observe?: 'body';
  params?: HttpParams;
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
}

export interface AuthConfig {
  redirectUrl: string,
  token: string,
  cookie: string,
  aoUrl: string,
  baseUrl: string,
  paymentGatewayUrl: string,
  useCookie: boolean,
  interceptor: any
}

export interface Authenticator {
  signIn?(username: string, password: string): Observable<User>;
  signOut(): Observable<boolean>;
}


export const AUTH_PROVIDERS = new InjectionToken<AuthProvider[]>('AUTH_PROVIDERS');
export const AUTH_CONFIG: InjectionToken<AuthConfig> = new InjectionToken<AuthConfig>('AUTH_CONFIG');

export abstract class AuthProvider implements Authenticator {
  PING_TIMER?: number;

  abstract isAuthenticated(): boolean;

  abstract ping?(): Observable<boolean>;
  abstract refresh?(local?: boolean): Observable<User>;
  abstract getToken?(): any;

  abstract signIn?(username: string, password: string): Observable<User>;
  abstract signOut(): Observable<boolean>;

  abstract intercept(request: HttpRequest<any>): HttpRequest<any>;
}




// WEBPACK FOOTER //
// ./src/app/auth/providers/auth.provider.ts